/** Shared DOM helpers for instant node selection feedback (matches React selection state). */

import { isBitmapSourceNode } from '../../cardBitmaps/findTaskElement';

export const SELECTED_NODE_CLASS_NAMES = [
  'task-node--selected',
  'decision-node--selected',
  'milestone-node--selected',
  'note-node--selected',
];

export const SELECTED_NODE_SELECTOR = SELECTED_NODE_CLASS_NAMES
  .map((className) => `.${className}`)
  .join(', ');

export const FLOWCHART_NODE_SELECTOR = '.task-node, .decision-node, .milestone-node';

export function clearSelectedNodeClasses(root = document) {
  root.querySelectorAll(SELECTED_NODE_SELECTOR).forEach((el) => {
    if (isBitmapSourceNode(el)) return;
    el.classList.remove(...SELECTED_NODE_CLASS_NAMES);
  });
}

function selectedClassFor(nodeEl) {
  if (nodeEl.classList.contains('note-node')) return 'note-node--selected';
  if (nodeEl.classList.contains('milestone-node')) return 'milestone-node--selected';
  if (nodeEl.classList.contains('decision-node')) return 'decision-node--selected';
  return 'task-node--selected';
}

export function applySelectedNodeClass(nodeEl) {
  if (!nodeEl || isBitmapSourceNode(nodeEl)) return;
  nodeEl.classList.add(selectedClassFor(nodeEl));
}

export function toggleSelectedNodeClass(nodeEl) {
  if (!nodeEl || isBitmapSourceNode(nodeEl)) return;
  nodeEl.classList.toggle(selectedClassFor(nodeEl));
}

export function selectAllFlowchartNodeClasses(root = document) {
  root.querySelectorAll(FLOWCHART_NODE_SELECTOR).forEach((el) => {
    if (isBitmapSourceNode(el)) return;
    applySelectedNodeClass(el);
  });
}
